var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedLimitStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ab413383-74df-405c-9a36-eac76c001c0d",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a212e998-e746-4065-8111-f98eb115599a",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.74,10.9h2.2a11.06,11.06,0,0,0-2.42-5.83L19,6.61A7.42,7.42,0,0,1,20.74,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.44,5.07,19,3.53A10.35,10.35,0,0,0,13.16,1V3.2A8.37,8.37,0,0,1,17.44,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,3.2V1A11.09,11.09,0,0,0,5.12,3.42L6.67,5A9.36,9.36,0,0,1,11,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59,5.07A10.82,10.82,0,0,0,1.06,10.9h2.2A9.36,9.36,0,0,1,5,6.61,20.09,20.09,0,0,0,3.59,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.06,23a11.08,11.08,0,0,1-11-9.9h2.2a9.08,9.08,0,0,0,8.8,7.7,8.77,8.77,0,0,0,8.68-7.59h2.2A10.88,10.88,0,0,1,12.06,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.54,7.38s-7.81,6.05-7.92,6.16a2,2,0,0,0,3,2.53C13.59,16,18.54,7.38,18.54,7.38Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedLimitStatus);
export default __webpack_public_path__ + "static/media/speed-limit-status.27707aa2b1b2e84d7e2874c71b8c4f95.svg";
export { ForwardRef as ReactComponent };